<template>
  <div class="left-warn-list" :style="{ left: left + 'px'}">
    <div class="title-box">
      <span class="title-g"></span>
      <img src="/static/img/home/title.png" alt="">
      <span v-if="warnData.length">紧急告警信息</span>
      <span v-else>历史告警信息</span>
      <span class="go-detail" @click="goMore">更多历史</span>
    </div>
    <ul>
      <template v-for="(item) in warnData">
        <li
          v-if="warnData.length"
          :key="item.id"
          class="warn-li"
          @click="handlealert(item)"
        >
          <div class="warn-img">
            <img src="/static/img/home/warin-icon.png" alt="">
          </div>
          <div class="left-ul">
            <p class="item-top">
              <span>{{ item.info.deviceData.name4Company }}</span>
              <span class="time">{{ item.info.warningTime }}</span>
            </p>
            <p class="item-bottom">
              <span>{{ item.info.deviceData.installPosition }}</span>
              <span class="status" style="color:#f1a512;border-color:#f1a512">
                {{ item.info.handleState === 0 ? '未处置' : item.info.handleState === 1 ? '处置中': '处置完成' }}
              </span>
            </p>
            <p v-if="item.info.deviceData.installPositionRemark" class="item-bottom item-bottoms">
              位置备注：{{ item.info.deviceData.installPositionRemark }}
            </p>
          </div>
        </li>
      </template>
      <template v-for="(item, index) in list">
        <!-- <li v-if="!warnData.length && list.length" :key="index"> -->
        <li :key="index">
          <img src="/static/img/home/warin-icon.png" alt="">
          <div class="left-ul">
            <p class="item-top">
              <span>{{ item.info.name4Company }}</span>
              <span class="time">{{ item.warningTime }}</span>
            </p>
            <p class="item-bottom">
              <span>{{ item.info.installPosition }}</span>
              <span class="status">{{ item.handleName }}</span>
            </p>
            <p v-if="item.info.installPositionRemark" class="item-bottom item-bottoms">
              位置备注：{{ item.info.installPositionRemark }}
            </p>
          </div>
        </li>
      </template>
      <li v-if="!list.length && !warnData.length" class="norData">
        暂无警告信息
      </li>
    </ul>
  </div>
</template>

<script>
import { formatDateTime } from '@/utils/objectUtil'
import { mapGetters } from 'vuex'

export default {
  name: 'ContentInfo',
  props: {
    warnList: {
      type: Array,
      default: () => [],
    },
    left: {
      type: Number,
      default: 20,
    },
  },

  computed: {
    ...mapGetters(['currentTab']),
  },

  watch: {
    currentTab (value) {
      this.warnData = []
      this.list = []
      this.getListReq(value)
    },
    warnList (list) {
      this.warnData = list
    },
  },

  data () {
    return {
      // 请求接口
      path: {
        listPath: '/api/device-warning-info/list',
      },
      warnData: [],
      list: [
        // {
        //   warningTime: '2020-10-12 08:54:15',
        //   handleName: '已处置',
        //   info: {
        //     name4Company: '设备1',
        //     installPosition: '河南省平顶山市鲁山县311国道',
        //     installPositionRemark: '河南省平顶河南省平顶山市鲁山县311国道01号路'
        //   }
        // },
      ],
    }
  },
  mounted () {
    this.warnData = this.warnList
    this.getListReq(this.currentTab)
  },
  methods: {
    goMore () {
      this.$router.push({ name: 'warningRecord' })
    },
    getListReq (groupId) {
      let { $http, path: { listPath } } = this
      // type === 2 重震
      $http.get(listPath, { pageIndex: 1, pageSize: 6, type: 2, groupId }).then(res => {
        if (res.code === 'success') {
          let list = res.data.list || []
          let listTemp = list.map(val => {
            val.warningTime = formatDateTime(new Date(val.warningTime), 'yyyy-MM-dd HH:mm:ss')
            val.handleName = val.handleState === 0 ? '未处置' : val.handleState === 1 ? '处置中' : '已处置'
            return val
          })
          this.list = listTemp
        }
      })
    },
    handlealert (item) {
      this.$emit('handlealert', item)
    },
  },
}
</script>

<style lang="less" scoped>
.left-warn-list {
  position: absolute;
  top: 210px;
  left: 20px;
  z-index: 9;
  width: 390px;
  padding: 20px;
  background: url('/static/img/home/list-bg.png') no-repeat;
  background-size: 100% 100%;
  transition: 0.5s;
  .title-box {
    border-radius: 5px;
    background-image: linear-gradient(to right, #05496D, transparent);
    color: #12AEF1;
    height: 32px;
    line-height: 32px;
    font-size: 18px;
    font-weight: bold;
    font-style: italic;
    img {
      vertical-align: -6px;
      margin-right: 10px;
    }
    .title-g {
      display: inline-block;
      width: 0;
      height: 10px;
      border: 2px solid #12AEF1;
      margin-right: 10px;
    }
    .go-detail {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      text-decoration: underline;
      float: right;
      color: #eee;
      cursor: pointer;
    }
  }
  ul {
    height: 530px;
    overflow: auto;
    li {
      color: #12AEF1;
      margin-top: 12px;
      padding-bottom: 10px;
      position: relative;
      &::after {
        content: '';
        position: absolute;
        bottom: -10px;
        left: 0px;
        width: 100%;
        height: 10px;
        background: url(/static/img/home/line.png) no-repeat;
        background-size: contain;
      }
      img {
        width: 60px;
      }
      .left-ul {
        display: inline-block;
        vertical-align: top;
        margin-left: 10px;
        width: calc(100% - 80px);
        font-style: italic;
        .item-top {
          font-size: 16px;
          .time {
            font-size: 14px;
            float: right;
          }
        }
        .item-bottom {
          // margin-top: 10px;
          color: #fff;
          font-size: 14px;
          // border: 1px solid red;
          height: 30px;
          line-height: 30px;
          span:nth-child(1) {
            display: inline-block;
            width: 228px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            // color: #ccc;
          }
          // font-size: 18px;
          .status {
            font-size: 12px;
            line-height: 12px;
            float: right;
            border: 1px solid #12AEF1;
            color: #12AEF1;
            padding: 4px 15px;
            border-radius: 40px;
            margin-top: 5px;
          }
        }
        .item-bottoms {
          font-style: normal;
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          color: #ccc;
          height: 20px;
          line-height: 20px;
        }
      }
    }
    li.warn-li {
      cursor: pointer;
      .warn-img {
        width: 60px;
        height: 60px;
        display: inline-block;
        position: relative;
        &::before {
          display: inline-block;
          content: '';
          width: 2px;
          height: 2px;
          position: absolute;
          top: 45%;
          left: 45%;
          border-radius: 50%;
          box-shadow: 0px 0px 40px 10px #fa0404;
          animation: biling 0.8s ease-in infinite;
        }
      }
    }
    .norData {
      height: 50px;
      line-height: 50px;
      text-align: center;
      &::after {
        display: none;
      }
    }
  }
}
@keyframes biling {
  from {
    box-shadow: 0px 0px 40px 10px #fa0404;
  }
  50% {
    box-shadow: 0px 0px 0px #fa0404;
  }
  to {
    box-shadow: 0px 0px 40px 10px #fa0404;
  }
}
</style>
